import React, { useState, useEffect, useRef } from "react";
import "../../css/CRUDModal.css";
import { ReactComponent as ChevronDownIcon } from "../../assets/Icons/Chevron down.svg";
import { ReactComponent as ChevronUp } from "../../assets/Icons/ChevronUp.svg";
import { axiosGetApi, axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";

const SellSMSModal = ({
  show,
  handleClose,
  editData,
  action,
  data,
  fetchData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [customerNameOpen, setCustomerNameOpen] = useState(false);
  const customerNameRef = useRef(null);
  const [vendorList, setVendorList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [vendorNameOpen, setVendorNameOpen] = useState(false);
  const toggleCustomerNameDropdown = () =>
    setCustomerNameOpen(!customerNameOpen);

  const handleClickOutside = (event) => {
    if (
      customerNameRef.current &&
      !customerNameRef.current.contains(event.target)
    ) {
      setCustomerNameOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (action === "add") {
      fetchCustomerData();
      setFormData({
        username: loggedInUserName,
        customerName: "",
        smsBalance: "",
        lastTopUpDate: "",
        currentRate: "",
        spocName: "",
        spocContactNo: "",
        amount: "",
        smsToBeTopUp: "",
      });
    }
  }, [action]);

  const fetchCustomerData = async () => {
    try {
      const response = await axiosGetApi(apiList.ALL_ACTIVE_CUSTOMER_DATA);

      if (response?.status === 200) {
        setCustomerList(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  const toggleVendorNameDropdown = () => {
    setVendorNameOpen(!vendorNameOpen);
    if (!vendorList.length) {
      // Fetch vendor data only if the list is empty
      fetchVendorData();
    }
  };

  const fetchVendorData = () => {
    axiosGetApi(apiList.ALL_ACTIVE_VENDOR_DATA)
      .then((response) => {
        if (response?.status === 200) {
          setVendorList(response?.data?.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [formData, setFormData] = useState({
    username: loggedInUserName,
    customerName: "",
    vendorName: "",
    smsBalance: "",
    currentRate: "",
    amount: "",
    smsToBeTopUp: "",
  });

  const [errors, setErrors] = useState({
    customerName: "",
    amount: "",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    if (id === "customerName") {
      let customerDetails = customerList.filter(
        (row) => row.name === value
      )?.[0];
      let tempFormData = {
        ...formData,
        [id]: value,
        ["smsBalance"]: customerDetails?.smsBalance,
        ["lastTopUpDate"]: customerDetails?.transactionDate,
        ["currentRate"]: customerDetails?.rate || "",
        ["spocName"]: customerDetails?.spocName || "",
        ["spocContactNo"]: customerDetails?.spocContactNo || "",
        ["customerId"]: customerDetails?.customerId,
        ["amount"]: "",
        ["smsToBeTopUp"]: "",
        ["vendorId"]: customerDetails?.vendorId,
        ["customerCode"]: customerDetails?.customerCode,
      };
      setFormData(tempFormData);
    } else if (id === "vendorName") {
      let vendorDetails = vendorList.filter(
        (row) => row.vendorName === value
      )?.[0];
      let tempFormData = {
        ...formData,
        [id]: value,
        ["vendorId"]: vendorDetails?.vendorId,
      };
      setFormData(tempFormData);
    } else if (id === "amount") {
      updatedValue = value.replace(/[^0-9]/g, "");
      // let topUpSMSValue = updatedValue * formData.currentRate * 100 || "";
      let topUpSMSValue = updatedValue / formData?.currentRate || "";
      setFormData({
        ...formData,
        [id]: updatedValue,
        ["smsToBeTopUp"]: topUpSMSValue,
      });
    } else {
      setFormData({ ...formData, [id]: updatedValue });
    }
  };

  const validate = () => {
    const newErrors = {};

    // Customer Name Validation
    if (!formData.customerName) {
      newErrors.customerName = "Customer Name is required";
    }

    // Amount To Be Top Up Validation
    if (!formData.amount) {
      newErrors.amount = "Amount To Be Top Up required";
    } else if (!/^\d{1,7}$/.test(formData.amount)) {
      newErrors.amount = "Amount must be maximum 7 digits";
    } else if (Number(formData.amount) === 0) {
      newErrors.amount = "Amount cannot be 0";
    }

    return newErrors;
  };

  const handleSellSMS = () => {
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitted(true);
      let apiUrl = "";
      let successMessage = "";

      if (action === "add") {
        apiUrl = apiList.CREATE_SELLSMS_DATA;
        successMessage = "SMS sold successfully";
      }

      axiosPostApi(apiUrl, formData)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status === true) {
            CustomAlert({
              title: action === "add" ? "SMS sold successfully." : "",
              text: response.data.message,
              icon: "success",
              confirmButtonText: "Ok",
            });
            // handleBack();
            handleClose();
            fetchData(1);
          }
          if (response?.data?.respCode === "02") {
            CustomAlert({
              title: "Warning",
              text:
                response?.data?.message || "Unable to proceed, check Balance",
              icon: "warning",
              confirmButtonText: "Okay",
            });
          }
        })
        .catch((error) => {
          console.error("Error processing customer request:", error);
          CustomAlert({
            title: "Error",
            text: "An error occurred while adding the SMS. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
    setFormData({
      username: loggedInUserName,
      customerName: "",
      vendorName: "",
      smsBalance: "",
      lastTopUpDate: "",
      currentRate: "",
      spocName: "",
      spocContactNo: "",
      amount: "",
      smsToBeTopUp: "",
    });
  };

  return (
    <>
      <div
        className={`modal-lg modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title main-title">Top-up SMS Details</h5>
            </div>
            <div className="scoped-modal modal-body">
              <form>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="customerName">
                      Customer Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <div
                      className="form-group position-relative"
                      ref={customerNameRef}
                    >
                      <select
                        className="form-control select-dropdown"
                        id="customerName"
                        placeholder="Role"
                        onClick={toggleCustomerNameDropdown}
                        onChange={handleInputChange}
                        value={formData.customerName}
                      >
                        <option value="" disabled selected>
                          Select Customer Name
                        </option>
                        {customerList?.map((customer) => {
                          return <option>{customer.name}</option>;
                        })}
                      </select>
                      <span className="position-absolute select-icon">
                        {customerNameOpen ? <ChevronUp /> : <ChevronDownIcon />}
                      </span>
                    </div>
                    {errors.customerName ? (
                      <span className="error">{errors.customerName}</span>
                    ) : null}
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="vendorName">
                      Vendor Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <div
                      className="form-group position-relative"
                      ref={customerNameRef}
                    >
                      <select
                        className="form-control select-dropdown"
                        id="vendorName"
                        placeholder="Role"
                        value={formData?.vendorName}
                        onClick={toggleVendorNameDropdown}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled selected>
                          Select Vendor Name
                        </option>
                        {vendorList?.map((vendor) => {
                          return <option>{vendor.vendorName}</option>;
                        })}
                      </select>
                      <span className="position-absolute select-icon">
                        {customerNameOpen ? <ChevronUp /> : <ChevronDownIcon />}
                      </span>
                    </div>
                    {errors.vendorName ? (
                      <span className="error">{errors.vendorName}</span>
                    ) : null}
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="smsBalance">SMS Balance</label>
                      <input
                        type="text"
                        className="form-control"
                        id="smsBalance"
                        placeholder="SMS Balance"
                        value={formData?.smsBalance}
                        style={{ textAlign: "right", cursor: "not-allowed" }}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="currentRate">Current Rate</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Current Rate"
                      id="currentRate"
                      value={formData?.currentRate}
                      style={{ textAlign: "right", cursor: "not-allowed" }}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="amount">
                      Amount to be Top-Up<span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        id="amount"
                        placeholder="Enter Amount"
                        value={formData?.amount}
                        style={{ textAlign: "right" }}
                        onChange={handleInputChange}
                      />
                      {errors.amount ? (
                        <span className="error">{errors.amount}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="smsToBeTopUp">SMS to be Top-Up</label>
                      <input
                        type="text"
                        className="form-control"
                        id="smsToBeTopUp"
                        placeholder="SMS to be Top-Up"
                        value={formData?.smsToBeTopUp}
                        style={{ textAlign: "right", cursor: "not-allowed" }}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="scoped-modal modal-footer">
              <button
                type="button"
                className="btn btn-back"
                onClick={handleBack}
              >
                Back
              </button>
              <button
                type="button"
                className="btn btn-submit"
                onClick={handleSellSMS}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default SellSMSModal;
